import { render, staticRenderFns } from "./migrationTaskList.vue?vue&type=template&id=206bc068&scoped=true&"
import script from "./migrationTaskList.vue?vue&type=script&lang=js&"
export * from "./migrationTaskList.vue?vue&type=script&lang=js&"
import style0 from "./migrationTaskList.vue?vue&type=style&index=0&id=206bc068&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206bc068",
  null
  
)

export default component.exports